import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericApiResponse } from './../models/api-response.model';

@Injectable({
    providedIn: 'root'
})
export class ComplaintService {

    constructor(private http: HttpClient) { }

    // GET request
    getUserComplaints(): Observable<Complaint[]> {
        return this.http.get<Complaint[]>('/complaints/v1/user-complaints');
    }

    // Post request
    updateComplaint(body: UpdateComplaintVo): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/complaints/v1/update-complaint', body);
    }

    getUserComplaintCategory(): Observable<ComplaintCategoryVo[]> {
        return this.http.get<ComplaintCategoryVo[]>('/complaint-category/v1/category-names');
    }

    getMasterComplaintCategories(categoryId: number): Observable<ComplaintCategoryMasterVo[]> {
        return this.http.get<ComplaintCategoryMasterVo[]>('/complaint-category/v1/master-category-names/{categoryId}'.replace('{categoryId}', categoryId.toString()));
    }

    getUserAllocatedLocations(): Observable<ResidentLocationVo[]> {
        return this.http.get<ResidentLocationVo[]>('/resident/v1/allocated-locations');
    }

    getAllocatedLocationsForAreaId(areaId: number): Observable<ResidentLocationVo[]> {
        return this.http.get<ResidentLocationVo[]>('/resident/v1/area-allocated-locations/{areaId}'.replace('{areaId}', areaId.toString()));
    }

    createComplaint(body: ComplaintRequest): Observable<ComplaintConfirmationVo[]> {
        return this.http.post<ComplaintConfirmationVo[]>('/complaints/v1/new-complaint', body);
    }

}

export interface ComplaintConfirmationVo {
    zoneId: number;
    complaintRefNumber: number;
    departmentId: number;
    departmentName: string;
    deptPhoneNumber: string;
    mobileNumber: string;
    sla: string;
    employeeRank: string;
    employeeDesignation: string;
    employeeName: string;
    assignedEmpMobile: string;
    allowSms: string;
    assignedEmail: string;
    allowEmail: string;
    employeeId: number;
    locationCode: string;
    locationName: string;
    complaintDes: string
    areaName: string;
    residentPriority: string;
    complaintCategory: string;
    complaintLines: ComplaintLineVo[];
    complaintCount: number | null;
    empPriority: string;
    ageMobile: string;
    geMobile: string;
    residentRank: string;
    residentFirstName: string;
    residentLastName: string;
    residentMobileNumber: string;
    residentEmailAddress: string;
}

export interface ComplaintLineVo {
    lineNumber: number;
    dueDate: Date;
    complaintDescription: string;
    complaintLineSatus: string;
}

export interface Complaint {
    complaintId: number;
    complaintDescription: string;
    residentId: number;
    employeeId: number;
    locationId: number;
    areaId: number;
    dueDate: Date;
    complaintStatus: string;
    complaintStatusMeaning: string;
    complaintDate: Date;
    userId: number;
    masterComplaintId: number;
    areaName: string;
    departmentName: string;
    locationCode: string;
    zoneId: number;
    complaintLineId: number;
    compSerialNum: number;
    complaintLineStatus: string;
    compLineStatusMeaning: string;
    lineCount: number;
    employeeName: string;
    employeeMobileNumber: string;
}

export interface UpdateComplaintVo {
    complaintId: number;
    complaintLineId: number;
    status: string;
}

export interface ComplaintCategoryVo {
    categoryName: string;
    categoryId: number;
}

export interface ComplaintCategoryMasterVo {
    complaintDescription: string;
    masterComplaintId: number;
    categoryId: number;
    priority: number;
    complaintMode: string;
}

export interface ResidentLocationVo {
    areaId: number;
    areaCode: string;
    areaName: string;
    areaDescription: string;
    zoneId: number;
    allocationId: number;
    residentId: number;
    allocationStartDate: Date | null;
    allocationEndDate: Date | null;
    locationId: number;
    locationCode: string;
    qtrNumber: string;
    blockNumber: string;
    locationDetail1: string;
    locationType: string;
    locationName: string | null;
    locationStartDate: Date;
    locationEndDate: Date | null;
    residentName: string;
}

export interface CreateComplaintDetail {
    categoryId: number;
    categoryName: string;
    masterComplaintId: number;
    masterComplaintDescription: string;
    comment: string;
    priorityId: number;
    complaintMode: String;
}

export interface ComplaintRequest {
    location: ResidentLocationVo;
    complaintDetails: CreateComplaintDetail[];
    preferredDay: string;
    preferredTime: string;
    complaintNotes: string;
}